"use client";

import React from "react";
import { ArrowUpRight, Compass, Sparkles } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Consultation() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 16
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.65,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <section id="call-to-action" data-nav="light" className="relative bg-background py-16 md:py-24">
      <div className="container mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: "-80px"
      }} variants={containerVariants} className="relative overflow-hidden rounded-xs bg-primary px-6 py-12 text-primary-foreground shadow-xl sm:px-12 md:py-16 lg:px-16">
          {/* Subtle architectural orbit motif in background */}
          <div aria-hidden="true" className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full border border-primary-foreground/10" />
          <div aria-hidden="true" className="pointer-events-none absolute -right-12 -top-12 h-72 w-72 rounded-full border border-primary-foreground/10" />
          <div aria-hidden="true" className="pointer-events-none absolute bottom-0 left-1/3 h-px w-2/3 bg-linear-to-r from-transparent via-primary-foreground/20 to-transparent" />

          <div className="relative z-10 flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
            <div className="max-w-2xl space-y-4">
              <div className="inline-flex items-center gap-2 rounded-xs border border-primary-foreground/20 bg-primary-foreground/10 px-3 py-1 text-xs font-medium uppercase tracking-widest text-primary-foreground">
                <Compass className="size-3.5" />
                <span>Anchor & Orbit Planning</span>
              </div>

              <h2 className="font-serif text-3xl font-medium tracking-tight text-primary-foreground sm:text-4xl md:text-5xl">
                Ready to balance the gathering and the getaway?
              </h2>

              <p className="text-base text-primary-foreground/90 sm:text-lg">
                Book a strategy call to apply the Anchor & Orbit method to your upcoming multi-generational gathering with complete logistical precision.
              </p>
            </div>

            <div className="flex flex-col items-start gap-3 sm:flex-row sm:items-center lg:flex-col lg:items-end">
              <Button asChild size="lg" className="h-12 rounded-xs border border-primary-foreground/40 bg-primary-foreground px-8 font-sans text-xs font-semibold uppercase tracking-wider text-primary shadow-md hover:bg-primary-foreground/90 hover:text-primary">
                <Link to="/AboutDiscoveryConsultationPage">
                  <span>Book a Strategy Call</span>
                  <ArrowUpRight className="size-4" />
                </Link>
              </Button>

              <div className="flex items-center gap-2 text-xs text-primary-foreground/75">
                <Sparkles className="size-3.5" />
                <span>30-minute private discovery consultation</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}